<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='8'>
          <wc-data-box
            title='Staging Modules'
            icon='mdi-view-column-outline'
          >
            <v-card-text>
              <h3>Snow Staging</h3>
              <staging-dashboard-stats
                v-if='Object.keys(this.dashboard).length'
                :data='this.dashboard.snow_data'
              />
              <v-row align="center" justify="center">
                <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-select
                    item-text="text"
                    item-value="value"
                    v-model="snow_selected_year"
                    :items="items"
                    @change='getDashboard()'
                />
               </v-col>
               <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-btn 
                    depressed 
                    class='primary' 
                    @click='show_confirm_snow_staging=true'
                    :loading='snow_loading'
                    small
                  >Run Staging</v-btn>
               </v-col>
               <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-btn 
                    depressed 
                    class='primary' 
                    @click="$router.push({name: 'StagingSnow', params: {'year': snow_selected_year}})"
                    small
                  >Open</v-btn>
               </v-col>
              </v-row>
              <v-divider class='my-4'></v-divider>
              <h3>Lawn Staging</h3>
              <staging-dashboard-stats
                v-if='Object.keys(this.dashboard).length'
                :data='this.dashboard.lawn_maintenance_data'
              />
              <v-row align="center" justify="center">
                <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-select
                    item-text="text"
                    item-value="value"
                    v-model="lawn_maintenance_year"
                    :items="items"
                    @change='getDashboard()'
                />
               </v-col>
               <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-btn 
                    depressed 
                    class='primary' 
                    @click='show_confirm_lawn_staging=true'
                    :loading='lawn_maintenance_loading'
                    small
                  >Run Staging</v-btn>
               </v-col>
               <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-btn 
                    depressed 
                    class='primary' 
                    @click="$router.push({'name': 'StagingLawn', params: {'year': lawn_maintenance_year}})"
                    small
                  >Open</v-btn>
               </v-col>
              </v-row>
              <v-divider class='my-4'></v-divider>
              <h3>Start Up Staging</h3>
              <staging-dashboard-stats
                v-if='Object.keys(this.dashboard).length'
                :data='this.dashboard.startup_data'
              />
              <v-row align="center" justify="center">
                <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-select
                    item-text="text"
                    item-value="value"
                    v-model="startup_selected_year"
                    :items="items"
                    @change='getDashboard()'
                />
               </v-col>
               <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-btn 
                    depressed 
                    class='primary' 
                    @click='show_confirm_startup_staging=true'
                    :loading='startup_loading'
                    small
                  >Run Staging</v-btn>
               </v-col>
               <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-btn 
                    depressed 
                    class='primary' 
                    @click="$router.push({'name': 'StagingStartup', params: {'year': startup_selected_year}})"
                    small
                  >Open</v-btn>
               </v-col>
              </v-row>
               <v-divider class='my-4'></v-divider>
              <h3>Blowdown Staging</h3>
              <staging-dashboard-stats
                v-if='Object.keys(this.dashboard).length'
                :data='this.dashboard.blowdown_data'
              />
              <v-row align="center" justify="center">
                <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-select
                    item-text="text"
                    item-value="value"
                    v-model="blowdown_selected_year"
                    :items="items"
                    @change='getDashboard()'
                />
               </v-col>
               <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-btn 
                    depressed 
                    class='primary' 
                    @click='show_confirm_blowdown_staging=true'
                    :loading='blowdown_loading'
                    small
                  >Run Staging</v-btn>
               </v-col>
               <v-col cols='12' md='4' class='d-flex justify-center'>
                  <v-btn 
                    depressed 
                    class='primary' 
                    @click="$router.push({'name': 'StagingBlowdown', params: {'year': blowdown_selected_year}})"
                    small
                  >Open</v-btn>
               </v-col>
              </v-row>
            </v-card-text>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
    <wc-dialog
      :showDialog='show_confirm_blowdown_staging'
      title='Run Blowdown Staging'
      width='600'
      :body_text='"Are you sure you want to run blowdown staging for " + blowdown_selected_year + "?"'
      saveText='Run'
      :loadingButtons="blowdown_loading"
      @save="runBlowdownStaging()"
      @cancel='show_confirm_blowdown_staging=false'
    >
    </wc-dialog>
    <wc-dialog
      :showDialog='show_confirm_startup_staging'
      title='Run Startup Staging'
      width='600'
      :body_text='"Are you sure you want to run startup staging for " + startup_selected_year + "?"'
      saveText='Run'
      :loadingButtons="startup_loading"
      @save="runStartupStaging()"
      @cancel='show_confirm_startup_staging=false'
    >
    </wc-dialog>
    <wc-dialog
      :showDialog='show_confirm_lawn_staging'
      title='Run Lawn Staging'
      width='600'
      :body_text='"Are you sure you want to run lawn staging for " + lawn_maintenance_year + "?"'
      saveText='Run'
      :loadingButtons="lawn_maintenance_loading"
      @save="runLawnMaintenanceStaging()"
      @cancel='show_confirm_lawn_staging=false'
    >
    </wc-dialog>
    <wc-dialog
      :showDialog='show_confirm_snow_staging'
      title='Run Snow Staging'
      width='600'
      :body_text='"Are you sure you want to run snow staging for " + snow_selected_year + "?"'
      saveText='Run'
      :loadingButtons="snow_loading"
      @save="runSnowStaging()"
      @cancel='show_confirm_snow_staging=false'
    >
    </wc-dialog>
  </div>
</template>

<script>
import stagingAPI from '@/api/staging';
import Stats from './common/dashboard/Stats';

export default {
  name: 'staging-dashboard',
  data: () => ({
    dashboard: {},
    items: [],
    snow_selected_year: "2022",
    startup_selected_year: "2022",
    blowdown_selected_year: "2022",
    lawn_maintenance_year: "2022",
    snow_loading: false,
    blowdown_loading: false,
    lawn_maintenance_loading: false,
    spring_cleanup_loading: false,
    startup_loading: false,
    show_confirm_blowdown_staging: false,
    show_confirm_startup_staging: false,
    show_confirm_lawn_staging: false,
    show_confirm_snow_staging: false
  }),
  created(){
     this.getData();
  },
  methods: {
    async getData(){
      this.getDates();
      this.getDashboard();
    },
    getDates(){
      const year = new Date().getFullYear();
      const year_string = year.toString();
      this.snow_selected_year = year_string;
      this.startup_selected_year = year_string;
      this.lawn_maintenance_year = year_string;
      this.blowdown_selected_year = year_string;

      this.items.push({"text": year_string, "value": year_string});
      const number_of_years = year - 2022;
      for(let i = 0; i < number_of_years; i++){
        const this_year = year - i - 1;
        const this_year_string = this_year.toString();
        this.items.push({"text": this_year_string, "value": this_year_string});
      }
    },
    async runBlowdownStaging(){
      this.blowdown_loading = true;
      await stagingAPI.runBlowdown(this.blowdown_selected_year, this.$store.state.auth.profile.id);
      this.getDashboard();
      this.show_confirm_blowdown_staging = false;
      this.blowdown_loading = false;
    },
    async runLawnMaintenanceStaging(){
      this.lawn_maintenance_loading = true;
      await stagingAPI.runLawnMaintenance(this.lawn_maintenance_year, this.$store.state.auth.profile.id);
      this.getDashboard();
      this.show_confirm_lawn_staging = false;
      this.lawn_maintenance_loading = false;
    },
    async runSnowStaging(){
      this.snow_loading = true;
      await stagingAPI.runSnow(this.snow_selected_year, this.$store.state.auth.profile.id);
      this.getDashboard();
      this.show_confirm_snow_staging = false;
      this.snow_loading = false;
    },
    async runStartupStaging(){
      this.startup_loading = true;
      await stagingAPI.runStartup(this.startup_selected_year, this.$store.state.auth.profile.id);
      this.getDashboard();
      this.show_confirm_startup_staging = false;
      this.startup_loading = false;
    },
    async getDashboard(){
      this.dashboard = await stagingAPI.getDashboard(
          this.startup_selected_year, 
          this.blowdown_selected_year,
          this.lawn_maintenance_year, 
          this.snow_selected_year
      );
    }
  },
  components: {
    'staging-dashboard-stats': Stats
  }
}
</script>
